<template>
<div> 
    <Slide :pageOption="pageOption" />
    <Home v-if="cPath=='Home'"  />
    <Ban v-if="cPath=='baned'"  :page="item" />
    <Register v-if="cPath=='register'" :page="item"  />
    <ForgotPassword v-if="cPath=='ForgotPassword'" :page="item"  />

</div>
</template>

<script>
import Home from '@/views/Home'
import Ban from '@/views/Member/Ban'
import Register from '@/views/Member/Register'
import ForgotPassword from '@/views/Member/ForgotPassword'
export default {

    components: {
        Home,
        Ban,
        Register,
        ForgotPassword
    },

    data: () => ({

        item: null,
        pageOption: null,

    }),

    computed: {
        cPath() {
            let cPath = this.$router.currentRoute.fullPath.replace("/", "")
            if (cPath == '') {
                cPath = 'Home';
            }
            return cPath;
        }
    },

    watch: {

    },
    methods: {

        getMainPage() {
            let data = {}
            data.slug = this.cPath
            const formData = this.$formData(
                data
            );
            let url = "page/mainPage";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.item = res.data.item
                    $vm.pageOption = res.data.pageOption
                    $vm.$MEMBER_ONLY_TEXT = null
                   

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {


        this.getMainPage()
   

    },
};
</script>
